import Auth from '@modules/auth/defs/api-routes';
import Users from '@modules/users/defs/api-routes';
import Therapists from '@modules/therapists/defs/api-routes';
import Uploads from '@modules/uploads/defs/api-routes';
import Posts from '@modules/posts/defs/api-routes';
import Notifications from '@modules/notifications/defs/api-routes';
import Leads from '@modules/leads/defs/api-routes';
import Admin from '@modules/admin/defs/api-routes';

const ApiRoutes = {
  Auth,
  Users,
  Therapists,
  Uploads,
  Posts,
  Notifications,
  Leads,
  Admin,
  Practices: { GetPractices: '/practices' },
};

export default ApiRoutes;
